import { Select } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";
import type { MarketplaceCustomerOption } from "../../types/marketplace";

type CustomerSelectProps = {
  customers: MarketplaceCustomerOption[];
  value?: string;
  onChange: (externalCustomerId: string | undefined) => void;
};

export function CustomerSelect({
  customers,
  value,
  onChange,
}: CustomerSelectProps) {
  const { t } = useTranslation();

  return (
    <Select
      label={t("common.customer")}
      placeholder={t("marketplace.selectCustomerPlaceholder")}
      options={customers.map((customer) => ({
        value: customer.externalCustomerId,
        label: customer.customerName,
      }))}
      value={value}
      onChange={(next: string | null) => onChange(next ?? undefined)}
    />
  );
}
